requireAsync("config").then(function([config]) {

	config.logLevel = 2;

});